import { Component, OnInit } from '@angular/core';
import { CustomerService } from '../../shared/customer/customer.service';
import { User } from '../../interface/user';
import { Customer } from '../../shared/customer/customer';
import { AuthService } from '../../shared/auth/auth.service';
import { HelpersService } from '../../shared/helpers/helpers.service';
import { Logging } from '../../logging';
import { ApiService } from '../../shared/api-service/api.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-main-dash',
  templateUrl: './main-dash.component.html',
  styleUrls: ['./main-dash.component.css']
})
export class MainDashComponent implements OnInit {

  data: Object;
  customers: Customer[] = [];
  resend_email_loading: Boolean = false;
  resend_code_loading: Boolean = false;
  user: User;
  availablebalance : any;
  actualbalance : any;
  unavailablebalance : any;

  availablepercent : any;
  unavailablepercentage: any;

  todaycount : any;
  approvallink : string;


  constructor( private api:ApiService,
               private auth: AuthService, 
               private route: ActivatedRoute,
               private router: Router,
               private helpers: HelpersService) { }

  ngOnInit() {
   
    if(!this.auth.user()){
      this.router.navigate(['/login']);
    }

    this.approvallink = this.auth.getApprovalLink();
    if(this.approvallink)
    {
     this.auth.removeApprovalLink();
      var appparts = this.approvallink.split('?');
      var paramparts = appparts[1].split('=');
      this.router.navigate([appparts[0]],{ queryParams: { r: paramparts[1] } });
    }

    if(this.auth.user().requirepasswordchange === true) //force user to change his password
    {
      this.router.navigate(['/account/change-password']);
    }
 
    this.fetchTopPannel();
  }


  fetchTopPannel()
  {
    this.api.get('/accounts/'+this.auth.getAccountID()+'/balance')
    .subscribe(
      res_data => {
      Logging.log(res_data);
      this.availablebalance = res_data.data[0].availablebalance;
      this.actualbalance = res_data.data[0].actualbalance;
      this.unavailablebalance = res_data.data[0].unavailablebalance;
      //this.availablepercent = Math.round((this.availablebalance/this.actualbalance) * 100);
      //this.unavailablepercentage = Math.round((this.unavailablebalance/this.actualbalance) * 100);
      this.availablepercent = ((this.availablebalance/this.actualbalance) * 100).toFixed(2);
      this.unavailablepercentage = ((this.unavailablebalance/this.actualbalance) * 100).toFixed(2);
      
      
      }, error_message => {
        this.helpers.flashDanger(error_message);

      }
    );

    this.api.get('/accounts/'+this.auth.getAccountID()+'/transcount/0')
    .subscribe(
      res_data => {
      Logging.log(res_data);
      this.todaycount = res_data.data[0].value;
      }, error_message => {
        this.helpers.flashDanger(error_message);

      }
    );


  }

  curuser(){
    return this.auth.user();
  }



}



// WEBPACK FOOTER //
// ./src/app/client/main-dash/main-dash.component.ts